import { render, staticRenderFns } from "./DrugManagement.vue?vue&type=template&id=db298164&scoped=true"
import script from "./DrugManagement.vue?vue&type=script&lang=js"
export * from "./DrugManagement.vue?vue&type=script&lang=js"
import style0 from "./DrugManagement.vue?vue&type=style&index=0&id=db298164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db298164",
  null
  
)

export default component.exports